import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { FilterDisplaySettings, BrandFilterContainerService } from '../brand-filter-container.service';
import { BrandsService } from '../../brands.service';

export interface Data {
  selectedSourceIds: string[];
  filterSettings: FilterDisplaySettings;
}

@Component({
  selector: 'bc-brand-geography-dialog',
  templateUrl: './brand-source-dialog.component.html',
  styleUrls: ['./brand-source-dialog.component.scss'],
  standalone: false,
})
export class BrandSourceDialogComponent implements OnInit {
  formControl = new UntypedFormControl();

  options$: Observable<any[]>;

  constructor(
    private brandService: BrandsService,
    public dialogRef: MatDialogRef<BrandSourceDialogComponent>,
    private readonly brandFiltersService: BrandFilterContainerService,
    @Inject(MAT_DIALOG_DATA) public data: Data,
  ) {}

  ngOnInit(): void {
    this.formControl.setValue(this.data.selectedSourceIds);

    this.options$ = this.brandFiltersService.sourceOptions$;
  }

  close(newData: boolean): void {
    if (!newData) {
      this.dialogRef.close();
      return;
    }
    this.dialogRef.close({
      selectedSourceIds: this.formControl.value || [],
    });
  }
}
